import React from "react";
import { AccountCreationConfirmationRequest } from "@planzone/dto";
import {
  useAccountCreationConfirmation,
  useAuthentication,
} from "@planzone/view-models";
import { Loader } from "../../common/loader";

import { Props } from "./types";
import { Form } from "./form";
import styles from "./styles.scss";

function AccountCreationConfirmation(props: Props) {
  const {
    account: { uuid },
  } = useAuthentication();
  const [request, setRequest] =
    React.useState<AccountCreationConfirmationRequest>(props);
  const { error, isRequestPending, confirmAccountCreation } =
    useAccountCreationConfirmation();

  return (
    <div className={styles.accountCreationConfirmation}>
      {isRequestPending && (
        <div className={styles.loader}>
          <div className={styles.loaderMain}>
            <Loader />
          </div>
        </div>
      )}
      <div className={styles.form}>
        <Form
          error={error}
          formData={request}
          editForm={setRequest}
          submitForm={(formData) =>
            confirmAccountCreation({ ...formData, userId: uuid })
          }
        />
      </div>
    </div>
  );
}

export { AccountCreationConfirmation };
